import { drupalSiteUrl } from "../../config";

export default {
	Any: "Any",
	BOOKMARK: "BOOKMARK",
	BOOKMARKED: "BOOKMARKED",
	CANCEL: "CANCEL",
	Category: "Category",
	Catalog: "Catalog",
	CERTIFICATE: "CERTIFICATE",
	CERTIFICATES: "CERTIFICATES",
	Certificate_Number: "Certificate Number",
	certificateInstructions: "To get credit, show this certificate at your WIC appointment",
	certificateIphoneHelp: "To save your certificate:",
	clickHere: "click here.",
	COMPLETE_CLASS: "COMPLETE CLASS",
	Completion_Date: "Completion Date",
	CONTINUE: "CONTINUE",
	completeAnonymously: "To complete your lesson without logging in, ",
	completeAnonymously2: "Complete your lesson without logging in",
	CurrentEmailAddress: "Current Email Address",
	dontHaveAnAccount: "Don't have an account?",
	DOWNLOAD_PDF: "DOWNLOAD PDF",
	EmailAddress: "Email Address",
	Filter: "Filter",
	footerText: `
		Call 800-942-3678 to learn more about Texas WIC. <a href=${`${drupalSiteUrl}/about-wic/contact-us`} target="_blank">Contact Us</a> | <a href="https://hhs.texas.gov/file-viewing-information" target="_blank">File Viewing Information</a> | <a href=${`${drupalSiteUrl}/health-partners`} target="_blank">Health Partners</a> | <a href="https://hhs.texas.gov/policies-practices-privacy" target="_blank">Internet Policy</a><br/>
		Site last updated Monday, April 9, 2018 This institution is an equal opportunity provider. © 2009-2018 TexasWIC.org / Health and Human Services Commission. All rights reserved.
		`,
	IN_PROGRESS: "IN-PROGRESS",
	keepingYourFamilyHealthy: "Keeping Your Family Healthy",
	languageToggle: "EN ESPAÑOL",
	loginMessage:
		"You do not have to log in, but logging in allows you to leave a class in the middle and come back later, track which classes you have completed, and bookmark classes you want to take another time.",
	LOG_IN: "LOG IN",
	Log_In: "Log In",
	LOG_OUT: "LOG OUT",
	LOGIN: "LOGIN",
	logoutPrompt: "Are you sure you wish to log out?",
	PRINT: "PRINT",
	PROFILE: "PROFILE",
	reenterEmail: "Re-Enter Email Address",
	REMOVE_BOOKMARK: "REMOVE BOOKMARK",
	satisfactionSurvey: "Satisfaction Survey",
	SAVE: "SAVE",
	SAVE_PICTURE: "SAVE PICTURE",
	SIGN_UP: "SIGN UP",
	signUp: "Sign up",
	skipToContent: "Skip to main content",
	START: "START",
	START_asterisk: "START*",
	SUBMIT: "SUBMIT",
	surveyInstructions:
		'Please complete the optional survey below to tell us about your experience using this lesson or press the "Complete Lesson" button below to get your certificate.',
	thanksForSigningUp: "THANKS FOR SIGNING UP",
	thankYouMessage:
		"Vestibulum laoreet lacus vitae blandit finibus. Aliquam erat volutpat. In turpis elit, ultricies vel massa ac, consectetur eleifend dolor.",
	thhs: "TEXAS HEALTH AND HUMAN SERVICES",
	updatedEmail: "Successfully updated email",
	viewAccessibilityVersion: "To access the accessible version of the class, ",
	viewAccessibilityVersion2: "View the accessible version of the class",
	whatYoullLearn: "WHAT YOU'LL LEARN",

	errors: {
		accountNotFound:
			"Account not found. Please check the email address entered or sign up for an account.",
		emailRequired: "Email address is required",
		existingAccount: "There is already an account with this email address",
		loginFailed: "Failed to login",
		matchEmails: "Email addresses do not match",
		registerFailed: "Failed to register account",

		failedToBookmark: "Failed to bookmark",
		failedToVerifyClass: "Failed to verify class id. Please use the link you were provided",
		failedToLoadClass: "Failed to load class details",
		failedToLoadClasses: "Failed to load courses",
		failedToUpdateEmail: "Failed to update email",
		failedToRegister: "You have already registered for this session",
	},
	faq: {
		questions: {
			question1: "What do I need to do to complete my WIC class?",
			question2: "What if I don't have a printer available?",
			question3:
				"How many classes do I need to complete to get credit for attending my WIC class?",
			question4: "Do I need to complete a specific class?",
			question5: "Can you email me a copy of my certificate?",
			question6:
				"If I log in to take a class what does TexasWIC.org use my email address for?",
			question7: "What should I do if the online classes are not working properly?",
			question8: "How do I update my email address?",
			question9: "The website looks different. Where did my completed class certificates go?",
		},
		answers: {
			answer1: `
					<a href="/login">Log in</a> with your email address, and you will see <span style="font-weight: bold">My
					Classes</span> and a <span style="font-weight: bold">Class Catalog</span>. Start the class you would like to take. At the end
					of the class you will receive a certificate. You can save, download, or print
					the certificate to show at your WIC appointment. You can also log in to <span style="font-weight: bold">My
					Classes</span> to show your certificate at your WIC appointment.
				`,
			answer2:
				"You can save or download a certificate to your phone to show at your WIC appointment. You can also log in to <span style='font-weight: bold'>My Classes</span> and show your completed certificate on your phone at your WIC appointment.",
			answer3:
				"To get credit you only need to complete one class before your WIC appointment.",
			answer4: "No. You may complete any class that interests you.",
			answer5:
				"No. Our current system does not email certificates. When you log in using your email address you will be able to see what classes you've completed. You can show these certificates at your WIC appointment.",
			answer6:
				"TexasWIC.org only uses your email address to save your progress in the classes and to save copies of your certificates. TexasWIC.org will not send you any unsolicited emails. You will only receive emails if you sign up for our newsletters.",
			answer7:
				"Send an email to <a href='mailto:WICGeneral@hhsc.state.tx.us'>WICGeneral@hhsc.state.tx.us</a> and let us know that the site is not working. If you are unable to complete your class, you will still be able to receive your WIC benefits at your appointment. However, you may be asked to complete a self-paced class or participate in a group class at the WIC office instead.",
			answer8:
				"After you log in, click on <span style='font-weight: bold'>Profile</span>. A window will open and display your current email address. Enter your new address and click save. The next time you log in, use your new email address. You will still see all of your class progress, bookmarked classes, and class certificates when you log in with the new email address.",
			answer9:
				"If you started a class or completed a class before May 10, 2018, the class history and progress did not move to the new TexasWIC.org. To get credit for your class, tell the WIC office that your certificate was lost because of the change.",
		},
	},
	survey: {
		questions: {
			question1: "How likely are you to try something you learned from this class?",
			question2:
				"How likely are you to recommend this class to a friend or family member on WIC?",
			question3: "What other class topics would be of interest to you?",
			question4: "Do you have any other comments about this class?",
		},
		answers: {
			extremelyLikely: "Extremely likely",
			somewhatLikely: "Somewhat likely",
			neitherLikelyOrUnlikely: "Neither likely or unlikely",
			somewhatUnlikely: "Somewhat unlikely",
			extremelyUnlikely: "Extremely unlikely",
		},
	},
	tabNames: {
		MY_CLASSES: "MY CLASSES",
		CATALOG: "CATALOG",
		FAQ: "FAQ",
	},
	type: {
		interactive: "Click & Learn",
		video: "Activity Video",
		recorded: "Pre-Recorded",
		live: "Live Online",
	},
	typeDescription: {
		interactive:
			"Interactive online classes you complete at your own pace. Available anytime—day or night.",
		video:
			"An activity video that you can participate in while watching. Available anytime—day or night.",
		recorded: "Video classes you can watch anytime—day or night.",
		live:
			"Classes broadcast live to your computer or phone. Available at scheduled dates and times.",
	},
	Dates_Time_Offered: "Dates and Times Offered",
	ENROLL: "ENROLL",
	Class_Topics: "Class Topics",
	Format: "Format",
	classDisclaimer:
		"*By clicking this link you are now leaving the Texas HHS Website. You are subject to that site's privacy and security policies when you leave our site.",
	completeClassLoginMessage:
		"You do not have to log in, but logging in allows you to store your certificate and track which classes you have completed.",
	classFull: "CLASS FULL**",
	registrationDisclaimer1: "**Registration for this class is full. Please check out our ",
	registrationDisclaimer2: "click and learn classes",
	registrationDisclaimer3:
		" that are available anytime, or check back for future dates and times of live classes.",
	youMayAlsoLike: "You May Also Like",
	liveClassCalendar: "Live Class Calendar",
	calendarDescription:
		'Live classes are 30-60 minutes long and offered at set days and times. View our two-week calendar to see upcoming live classes. Choose a topic that interests you and register by selecting "Learn more."',
	returnToCatalog: "Return to Catalog",
	learnMore: "Learn More",
	hostedBy: "Hosted By",
	FirstName: "First Name",
	LastName: "Last Name",
	DontRegisterNow: "Don't register now",
	liveClassDescription: "Classes are conducted on Livestorm, a 3rd party webinar platform.",
	liveClassDescription1: "For more information read our <a href='/faq?language=en'>FAQs</a>",
	livestormTerms:
		"I agree to <a href='https://livestorm.imgix.net/1127/1639478106-cgu-s-en.pdf'>Livestorm's Terms of Service</a> and the use of personal data as explained in <a href='https://livestorm.imgix.net/1127/1637919685-pp-eng.pdf'>Livestorm's Privacy and Security Policy</a>, which may not be the same as the Texas HHS privacy and security policy that applies to the rest of this site.*",
	Save: "Save",
	Cancel: "Cancel",
	myWic: "myWic",
	linkToMyWicInstructions:
		"Link your TexasWIC.org profile to your myWIC account for easy access to your completed online class information any time.",
	linkYourMyWicAccount: "Link Your myWIC Account",
	linkToMyWic: "Link myWIC Account",
	whatsThis: "Learn more about myWIC",
	currentlyLinkedToMyWic: "Your TexasWIC.org profile is linked to myWIC.",
	ChangeEmailAddress: "Change Email Address",
	ChangeEmailAddressInstructions:
		"Has your email address changed? After you update your email, remember to link your new email address to myWIC. Questions? Visit our ",
	ClassesFAQ: "Classes FAQ.",
	EnterNewEmail: "Enter new email address:",
	ReenterNewEmail: "Re-enter new email address:",
};



// WEBPACK FOOTER //
// ./src/constants/strings/english.js